import { defineMessages } from 'react-intl';

export const messages: {
	thumbsUp: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	thumbsDown: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	thanksForFeedback: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	whatWentWrong: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	queryDoesNotRun: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	wrongResults: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	didNotFollowAsk: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	otherReason: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	thumbsUp: {
		id: 'dtac.labs.cyphie.chatMessage.thumbsUp.non-final',
		defaultMessage: 'Thumbs up',
		description: 'Button that marks a Cyphie response as helpful.',
	},
	thumbsDown: {
		id: 'dtac.labs.cyphie.chatMessage.thumbsDown.non-final',
		defaultMessage: 'Thumbs down',
		description: 'Button that marks a Cyphie response as unhelpful.',
	},
	thanksForFeedback: {
		id: 'dtac.labs.cyphie.chatMessage.thanksForFeedback.non-final',
		defaultMessage: 'Thanks for the feedback',
		description: 'Shown beside the rating buttons after a Cyphie response is marked helpful.',
	},
	whatWentWrong: {
		id: 'dtac.labs.cyphie.chatMessage.whatWentWrong.non-final',
		defaultMessage: 'What went wrong?',
		description:
			'Question shown under the rating buttons after a Cyphie response is marked unhelpful.',
	},
	queryDoesNotRun: {
		id: 'dtac.labs.cyphie.chatMessage.queryDoesNotRun.non-final',
		defaultMessage: "Query doesn't run",
		description: 'Option for feedback that the Cypher query from Cyphie does not run.',
	},
	wrongResults: {
		id: 'dtac.labs.cyphie.chatMessage.wrongResults.non-final',
		defaultMessage: 'Wrong results',
		description: 'Option for feedback that a Cyphie response returned the wrong results.',
	},
	didNotFollowAsk: {
		id: 'dtac.labs.cyphie.chatMessage.didNotFollowAsk.non-final',
		defaultMessage: "Didn't follow my ask",
		description: 'Option for feedback that a Cyphie response did not follow the user request.',
	},
	otherReason: {
		id: 'dtac.labs.cyphie.chatMessage.otherReason.non-final',
		defaultMessage: 'Other',
		description: 'Option for feedback that does not match the listed reasons.',
	},
});
